module.exports = __webpack_public_path__ + "static/img/Hera_logo.c58d4e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/Hera_logo.png
// module id = H/fw
// module chunks = 0